module.exports = __webpack_public_path__ + "img/Dc.17d07844.png";